import React from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { ProductsList } from "./ProductsList"; // ✅ your product data
import ProductCard from "./ProductCard"; // ✅ your existing product card
import { ArrowLeft } from "lucide-react";
const CategoryPage = () => {
  const navigate = useNavigate();
  const param = useParams();
  let products = [];
  if (param.category === "supersale") {
    const allProducts = Object.values(ProductsList).flatMap(
      (category) => category.products
    );
    products = allProducts.filter(
      (product) => product.sale_price && product.sale_price !== ""
    );
    // console.log("sale");
  } else {
    products = ProductsList[param.category].products;
  }

  return (
    <>
      <header className="bg-white shadow-sm">
        <div className="container mx-auto px-4 py-4 flex justify-between items-center">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center text-gray-700 hover:text-[#fe7590] cursor-pointer"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Back
          </button>
        </div>
      </header>
      <div className="bg-gray-100 py-10">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-4xl font-extrabold text-center text-gray-800 mb-10">
            {/* Shop by Category */}
          </h1>

          <section
            key={param.category}
            className="mb-16 scroll-mt-24"
            id={`category-${param}`}
          >
            {/* Category Heading */}
            <div className="mx-auto md:mx-0 text-center md:text-left">
              <h2 className="text-2xl md:text-3xl font-bold bg-gradient-to-r from-orange-500 to-pink-500 text-white py-3 px-5 rounded-lg shadow-md inline-block mb-6 ">
                {param.category}
              </h2>
            </div>

            {/* Products Grid */}
            <div className="flex flex-wrap justify-center gap-6">
              {products.length > 0 ? (
                products.map((product) => (
                  <ProductCard key={product.id} product={product} />
                ))
              ) : (
                <p className="text-gray-500 text-center w-full">
                  No products available in this category.
                </p>
              )}
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default CategoryPage;
